import { Controller } from "@hotwired/stimulus"

// A borough already says where someone is, so the address fields stay hidden
// until the region answer is the one the borough list cannot place.
export default class extends Controller {
  static targets = ["region", "addressFields"]
  static values = { outsideRegion: String }

  connect() {
    this.toggle()
  }

  toggle() {
    const outside = this.regionTargets.some(
      (region) => region.checked && region.value === this.outsideRegionValue
    )

    this.addressFieldsTarget.classList.toggle("hidden", !outside)

    // Hiding alone is not enough — hidden inputs still serialize, which would
    // save an address behind a profile that has picked a borough.
    this.addressFieldsTarget.querySelectorAll("input").forEach((field) => {
      field.disabled = !outside
    })
  }
}
